import { css } from '@emotion/css';
import { unsafe_keyframes, useTokens } from '@gemini/core';
const skeletonAnimation = unsafe_keyframes({
    '0%': { backgroundPosition: '100% 50%' },
    '100%': { backgroundPosition: '0% 50%' },
});
const createSkeletonCSS = (tokens) => css `
    background: linear-gradient(
            90deg,
            ${tokens['color.background.subdued']} 25%,
            ${tokens['color.background.light']} 37%,
            ${tokens['color.background.subdued']} 63%
        )
        transparent;
    background-size: 400% 100%;
    animation-duration: 1400ms;
    animation-iteration-count: infinite;
    animation-timing-function: ${tokens['motionEasing.ease']};
    animation-name: ${skeletonAnimation};
`;
export const useSkeleton = () => {
    const tokens = useTokens();
    return {
        skeletonClassName: createSkeletonCSS(tokens),
    };
};
